// Footer.jsx
import React from 'react';
import logofooter from '../assets/logo_tracking_footer_2.png';

const Footer = () => {
  const footerLinks = [
    { name: 'Términos de Servicio', href: '/terminos-de-servicio' },
    { name: 'Política de Privacidad', href: '/politica-privacidad' },
    {
      /*
    { name: 'Soporte', href: '/soporte' },
     */
    },
  ];

  return (
    <footer className="w-full bg-packsys-orange">
      <div className="max-w-12xl mx-auto px-6 py-8">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <div className="flex items-center space-x-3 mb-4 md:mb-0">
            <a href="/">
              <img
                className="h-12 transition-transform duration-300 hover:scale-110"
                src={logofooter}
                alt="Imagotipo Packsys"
              />
            </a>
          </div>
          <div className="flex space-x-8">
            {footerLinks.map((item) => (
              <a
                key={item.name}
                href={item.href}
                className="text-white hover:text-blue-100 transition-all duration-300 font-medium relative group"
              >
                {item.name}
                <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-white transition-all duration-300 group-hover:w-full"></span>
              </a>
            ))}
          </div>
        </div>
        <div className="border-t border-white/20 mt-6 pt-6">
          <p className="text-center text-white/90 text-sm">
            Copyright © {new Date().getFullYear()}{' '}
            <a
              href="https://tracking.packsys.com/"
              className="text-[#0061A1] font-semibold"
            >
              Tracking Packsys.
            </a>{' '}
            Todos los derechos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
